import React from 'react';
import './card-style.css';

const Cardi = props => {
    return(
        <div className="card text-center shadow">
            <div className="overflow">
                <img src={props.imgsrc} alt="Image1" className="card-img-top"></img>
            </div>
            <div className="card-body text-dark">
                <h4 className="card-title">{props.title}</h4>
                <p className="card-text text-secondary">
                    {props.description}
                </p>
                <a href={props.href} className="btn btn-outline-primary">Click Here</a>
            </div>
        </div>
    );
}

export default Cardi;